import { gql } from '@apollo/client';

const GET_GROUPS = gql`
  query GetGroups(
    $filter: GroupArgsFilter!
    $limit: Int
    $offset: Int
    $sorter: GroupArgsSorter
  ) {
    groups(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
      nodes {
        id
        name
        color
        folderId
        createdAt
        updatedAt
        users {
          id
          auth0Id
          firstName
          lastName
          email
          pictureURL
          activityStatus
          updatedAt
          createdAt
        }
        resourceAccess {
          id
          resourceId
          permissions
        }
        createdBy {
          id
          email
          firstName
          lastName
          pictureURL
        }
      }
      pageInfo {
        offset
        totalCount
      }
    }
  }
`;

export default GET_GROUPS;
